/*eslint no-undef: "off"*/

// Children of ViewAuthenticated for accounts & user management
export const accountsRoutes = [
    {
        path: 'settings/users',
        name: 'settings-users',
        component: () => import('@/views/UsersIndexView.vue'),
        meta: { title: 'Users' },
    },
    {
        path: 'accounts',
        component: () => import('@/features/accounts/views/AccountsRouterView.vue'),
        // Guard at the route level so child views never mount and fire admin-only fetches (SER-13616).
        beforeEnter() {
            const currentUser = useCurrentUserStore()

            if (!currentUser.isAdmin) return { path: '/home' }
        },
        children: [
            {
                path: '',
                name: 'accounts-index',
                components: {
                    default: () => import('@/features/accounts/views/AccountsIndexView.vue'),
                    heading: () => import('@/features/accounts/views/AccountsIndexHeadingView.vue'),
                    modalCreate: () => import('@/features/accounts/views/AccountsRecordCreateView.vue'),
                },
            },
            {
                path: ':accountId',
                components: {
                    default: () => import('@/features/accounts/views/record/AccountsRecordRouterView.vue'),
                    heading: () => import('@/features/accounts/views/record/AccountsRecordHeadingView.vue'),
                    modalEdit: () => import('@/features/accounts/views/record/AccountsRecordEditView.vue'),
                    modalDelete: () => import('@/features/accounts/views/record/AccountsRecordDeleteView.vue'),
                },
                meta: { title: 'Account Details' },
                children: [
                    {
                        path: '',
                        name: 'accounts-record',
                        redirect: { name: 'accounts-record-pulls' },
                    },
                    {
                        path: 'pulls',
                        components: {
                            leftColumn: () =>
                                import('@/features/accounts/views/record/pulls/AccountsRecordTargetsCollectionView.vue'),
                            default: () =>
                                import('@/features/accounts/views/record/pulls/AccountsRecordPullsRouterView.vue'),
                        },
                        children: [
                            {
                                path: '',
                                name: 'accounts-record-pulls',
                                components: {
                                    list: () =>
                                        import('@/features/accounts/views/record/pulls/AccountsRecordPullsIndexView.vue'),
                                },
                            },
                            {
                                path: 'create',
                                name: 'accounts-record-pulls-create',
                                redirect: { name: 'accounts-record-pulls-create-payor' },
                            },
                            {
                                path: 'create/payor',
                                name: 'accounts-record-pulls-create-payor',
                                components: {
                                    list: () =>
                                        import('@/features/accounts/views/record/pulls/AccountsRecordPullsCreatePayorView.vue'),
                                },
                            },
                            {
                                path: 'create/health-system',
                                name: 'accounts-record-pulls-create-health-system',
                                components: {
                                    list: () =>
                                        import('@/features/accounts/views/record/pulls/AccountsRecordPullsCreateHealthSystemView.vue'),
                                },
                            },
                            {
                                path: ':pullId',
                                name: 'accounts-record-pulls-record',
                                components: {
                                    list: () =>
                                        import('@/features/accounts/views/record/pulls/AccountsRecordPullsIndexView.vue'),
                                    default: () =>
                                        import('@/features/accounts/views/record/pulls/AccountsRecordPullsRecordView.vue'),
                                },
                            },
                        ],
                    },
                    {
                        path: 'transfers',
                        name: 'accounts-record-transfers',
                        components: {
                            default: () =>
                                import('@/features/accounts/views/record/transfers/AccountsRecordTransfersIndexView.vue'),
                        },
                    },
                    {
                        path: 'deliveries',
                        components: {
                            leftColumn: () =>
                                import('@/features/accounts/views/record/deliveries/AccountsRecordDeliveriesDefaultsView.vue'),
                            default: () =>
                                import('@/features/accounts/views/record/deliveries/AccountsRecordDeliveriesRouterView.vue'),
                        },
                        children: [
                            {
                                path: '',
                                name: 'accounts-record-deliveries',
                                components: {
                                    list: () =>
                                        import('@/features/accounts/views/record/deliveries/AccountsRecordDeliveriesListView.vue'),
                                },
                            },
                            {
                                path: ':deliveryId',
                                name: 'accounts-record-deliveries-record',
                                components: {
                                    list: () =>
                                        import('@/features/accounts/views/record/deliveries/AccountsRecordDeliveriesListView.vue'),
                                    default: () =>
                                        import('@/features/accounts/views/record/deliveries/AccountsRecordDeliveriesRecordView.vue'),
                                },
                            },
                        ],
                    },
                    {
                        path: 'configuration',
                        name: 'accounts-record-configuration',
                        components: {
                            default: () =>
                                import('@/features/accounts/views/record/config/AccountsRecordConfigIndexView.vue'),
                        },
                    },
                    {
                        path: 'products',
                        components: {
                            leftColumn: () =>
                                import('@/features/accounts/views/record/products/AccountsRecordProductsLeftColumnView.vue'),
                            default: () =>
                                import('@/features/accounts/views/record/products/AccountsRecordProductsRouterView.vue'),
                        },
                        children: [
                            {
                                path: '',
                                name: 'accounts-record-products',
                                components: {
                                    default: () =>
                                        import('@/features/accounts/views/record/products/AccountsRecordProductsIndexView.vue'),
                                },
                            },
                            {
                                path: 'provider-groups',
                                name: 'accounts-record-products-provider-groups',
                                components: {
                                    default: () =>
                                        import('@/features/accounts/views/record/products/AccountsRecordProductsProviderGroupsIndexView.vue'),
                                },
                            },
                            {
                                path: 'code-groups',
                                name: 'accounts-record-products-code-groups',
                                components: {
                                    default: () =>
                                        import('@/features/accounts/views/record/products/AccountsRecordProductsCodeGroupsIndexView.vue'),
                                },
                            },
                        ],
                    },
                    {
                        path: 'users',
                        name: 'accounts-record-users',
                        component: () => import('@/features/accounts/views/record/users/AccountsRecordUsersView.vue'),
                    },
                ],
            },
        ],
    },
]
